<!--
/**
  * 树形下拉框组件
  * @author weili
  */
-->
<template>
  <div style="width:100%;">
    <el-popover  v-model="isShowSelect" placement="bottom-start" trigger="click" 
               :append-to-body="false" popper-class="tree-popper" style="padding: 12px 0;" @hide="popoverHide">
      <el-input v-show="isShowFilter" v-model="filterText" placeholder="输入关键字进行过滤"/>
      <el-tree
        ref="selectTree"
        class="common-tree"
        :data="data"
        :props="defaultProps"
        :show-checkbox="multiple"
        :node-key="nodeKey"
        :check-strictly="checkStrictly"
        :default-expand-all="defaultExpandAll"
        :filter-node-method="filterNode"
        :expand-on-click-node="expandOnClickNode"
        :check-on-click-node="multiple"
        :highlight-current="true"
        @node-click="handleNodeClick"
        @check-change="handleCheckChange"
      />
      <el-select
        slot="reference"
        ref="select"
        v-model="selectedData"
        :multiple="multiple"
        :placeholder="placeholder"
        :clearable="clearable"
        :collapse-tags="collapseTags"
        class="tree-select"
        @remove-tag="removeSelectedNodes"
        @clear="removeSelectedNode"
        @change="changeSelectedNodes"
      >
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" class="tree-select__option"/>
      </el-select>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'EXSelectTree',
  props: {
    formData: {
      type: Object,
      default() {
        return {}
      }
    },
    value: {
      type: String,
      default() {
        return ""
      }
    },
    // 树结构数据
    data: {
      type: Array,
      default() {
        return []
      }
    },
    defaultProps: {
      type: Object,
      default() {
        return {
          children: 'children',
          label: 'name'
        }
      }
    },
    // 配置是否可多选
    multiple: {
      type: Boolean,
      default() {
        return false
      }
    },
    placeholder :{
        type: String,
        default: "请选择",
      },
    // 配置是否可清空选择
    clearable: {
      type: Boolean,
      default() {
        return true
      }
    },
    // 配置多选时是否将选中值按文字的形式展示
    collapseTags: {
      type: Boolean,
      default() {
        return false
      }
    },
    nodeKey: {
      type: String,
      default() {
        return 'id'
      }
    },
    // 显示复选框情况下，是否严格遵循父子不互相关联
    checkStrictly: {
      type: Boolean,
      default() {
        return false
      }
    },
    // 是否在点击节点时展开或收缩节点
    expandOnClickNode: {
      type: Boolean,
      default() {
        return false
      }
    },
    // 默认选中的节点key数组
    // checkedKeys: {
    //   type: Array,
    //   default() {
    //     return []
    //   }
    // },
    size: {
      type: String,
      default() {
        return 'medium'
      }
    },
    // 是否开启过滤功能
    isShowFilter: {
      type: Boolean,
      default() {
        return true
      }
    },
    // 是否默认展开所有节点
    defaultExpandAll: {
      type: Boolean,
      default() {
        return false
      }
    },
    // 单选是否只能选叶子节点
    isOnlyLeaf: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    checkedKeys: {
      get() {
        var value = this.formData[this.value]
        if (value) {
          let ids = value.toString().split(',')
          var arr = []
          ids.map(id=>{
             arr.push(id)
          })
          return arr
        }
        return []
      },
      set() { },
    },
  },
  data() {
    return {
      filterText: '', // 模糊搜索文本
      isShowSelect: false, // 是否显示树状选择器
      options: [], // 下拉框选项
      selectedData: [], // 下拉框选中的节点
      checkedIds: [],
      checkedData: []
    }
  },
  watch: {
    formData (val) {
        this.initCheckedData()
    },
    isShowSelect(val) {
      // 隐藏select自带的下拉框
      this.$refs.select.blur()
    },
    // checkedKeys: {
    //   handler(val) {
    //     console.log('checkedKeys', val)
    //     if (!val) return
    //     this.checkedKeys = val
    //     alert(2)
    //     this.initCheckedData()
    //   },
    //   immediate: true,
    //   deep: true
    // },
    data: {
      handler(val) {
        this.initCheckedData()
      },
      immediate: true,
      deep: true
    },
    filterText(val) {
      this.$refs.selectTree.filter(val)
    }
    // selectedData: {
    //   handler(val) {
    //     const dataList = this.treeToList(this.data)
    //     this.selectedObj = dataList.filter((item) => {
    //       return this.selectedData.indexOf(item[this.nodeKey]) !== -1
    //     })
    //   },
    //   immediate: true,
    //   deep: true
    // }
  },

  created() {
    this.initCheckedData()
  },
  methods: {
    //   树节点筛选
    filterNode(value, data) {
      if (!value) return true
      return data[this.defaultProps.label].indexOf(value) !== -1
    },
    // 单选时点击tree节点，设置select选项
    setSelectOption(node) {
      const tmpMap = {}
      if(node){
        tmpMap.value = node.key
        tmpMap.label = node.label
        this.selectedData = node.label
      }
      this.options = []
      this.options.push(tmpMap)
    },
    // 单选，选中传进来的节点（刚进页面时调用，回显到树）
    checkSelectedNode(checkedKeys) {
      this.$nextTick(() => {
         var item = checkedKeys[0]
         this.$refs.selectTree.setCurrentKey(item)
         var node = this.$refs.selectTree.getNode(item)
         this.setSelectOption(node)
         this.handleNodeClick() // 下拉框回填
      })
    },
    // 多选，勾选上传进来的节点（刚进页面时调用，回显到树）
    checkSelectedNodes(checkedKeys) {
      // 优化select回显显示 有个延迟的效果
      const that = this

      this.$nextTick((_) => {
        that.$refs.selectTree.setCheckedKeys(checkedKeys) // 树回填
        that.handleCheckChange() // 下拉框回填
      })
    },
    // 单选，清空选中
    clearSelectedNode() {
      this.selectedData = [] // 下拉框选中清空
      this.$nextTick(() => {
        this.$refs.selectTree.setCurrentKey(null) // 树选中清空
      })
      this.selectedData = ''
    },
    // 多选，清空所有勾选
    clearSelectedNodes() {
      this.$nextTick(() => {
        var checkedKeys = this.$refs.selectTree.getCheckedKeys() // 所有被选中的节点的 key 所组成的数组数据
        for (let i = 0; i < checkedKeys.length; i++) {
          this.$refs.selectTree.setChecked(checkedKeys[i], false) // 遍历取消所有树勾选
        }
        this.selectedData = []
      })
    },
    initCheckedData() {
      if (this.multiple) {
        // 多选
        if (this.checkedKeys.length > 0) {
          this.checkSelectedNodes(this.checkedKeys) // 树和下拉框回填
        } else {
          this.clearSelectedNodes()
        }
      } else {
        // 单选
        if (this.checkedKeys.length > 0) {
          this.checkSelectedNode(this.checkedKeys)
        } else {
          this.clearSelectedNode()
        }
      }
    },
    popoverHide() {
      if (this.multiple) {
        this.checkedIds = this.$refs.selectTree.getCheckedKeys() // 所有被选中的节点的 key 所组成的数组数据
        this.checkedData = this.$refs.selectTree.getCheckedNodes() // 所有被选中的节点所组成的数组数据
      } else {
        this.checkedIds = this.$refs.selectTree.getCurrentKey()
        this.checkedData = this.$refs.selectTree.getCurrentNode()
      }
      this.$emit('popoverHide', this.checkedIds, this.checkedData)
    },
    // 单选，节点被点击时的回调,返回被点击的节点数据
    handleNodeClick(data, node) {
      if (this.isOnlyLeaf) {
        if (data.children && data.children.length !== 0) {
          return
        }
      }
      if (!this.multiple) {
        this.setSelectOption(node)
        // this.isShowSelect = !this.isShowSelect   
        this.isShowSelect = false              //解决页面回显初始化显示弹出框的问题
        // this.$emit('change', this.selectedData)
        if(node){
          this.$set(this.formData, this.value, node.key); //回填表单值
          this.$forceUpdate();
          this.$emit('change', data)
        }
      }
    },
    // 多选，节点勾选状态发生变化时的回调
    handleCheckChange() {
      var checkedKeys = this.$refs.selectTree.getCheckedKeys() // 所有被选中的节点的 key 所组成的数组数据

      //   将选中数据设置为下拉框选项数据
      this.options = checkedKeys.map((item) => {
        var node = this.$refs.selectTree.getNode(item) // 所有被选中的节点对应的node
        const tmpMap = {}
        tmpMap.value = node.key
        tmpMap.label = node.label
        return tmpMap
      })
      //   将所有选项勾选
      this.selectedData = this.options.map((item) => {
        return item.value
      })
      this.$set(this.formData, this.value, this.selectedData.join()); //回填表单值
      this.$forceUpdate();
      this.$emit('change', this.selectedData.join())
    },
    // 多选,删除任一select选项的回调
    removeSelectedNodes(val) {
      this.$refs.selectTree.setChecked(val, false) // 取消树节点选中状态
      var node = this.$refs.selectTree.getNode(val) // 拿到此节点对应的node
      if (!this.checkStrictly && node.childNodes.length > 0) {
        this.treeToList(node).map((item) => {
          if (item.childNodes.length <= 0) {
            this.$refs.selectTree.setChecked(item, false)
          }
        })
        this.handleCheckChange()
      }
      this.$set(this.formData, this.value, this.selectedData.join()); //回填表单值
      this.$forceUpdate();
      this.$emit('change', this.selectedData.join())
    },
    // 将树扁平化，转化为列表
    treeToList(tree) {
      var queen = []
      var out = []
      queen = queen.concat(tree)
      while (queen.length) {
        var first = queen.shift() // 拿到第一个值并从queen删除
        // 如果有子节点，拼在queen后面
        if (first[this.defaultProps.children]) {
          queen = queen.concat(first[this.defaultProps.children])
        }
        out.push(first)
      }
      return out
    },
    // 单选,清空select输入框的回调
    removeSelectedNode() {
      this.clearSelectedNode()
      this.$set(this.formData, this.value, this.selectedData); //回填表单值
      this.$forceUpdate();
      this.$emit('change', this.selectedData)
    },
    // 选中的select选项改变的回调
    changeSelectedNodes(selectedData) {
      // 多选,清空select输入框时，清除树勾选
      if (this.multiple && selectedData.length <= 0) {
        this.clearSelectedNodes()
      }
      this.$set(this.formData, this.value, this.selectedData); //回填表单值
      this.$forceUpdate();
      this.$emit('change', this.selectedData)
    }
  }
}
</script>

<style scoped lang="scss">
.common-tree {
  overflow-y: auto;
  // overflow-x: hidden;
  max-height: 3.5rem;
}

.tree-select {
  z-index: 111;
}
/deep/ .el-input--small .el-input__inner {
  width: 100% !important;
  margin-left: 0;
}

.el-popover__reference{
  width: 100%;
}
/deep/ .el-tree-node__content {
  height: 0.4rem;
  line-height: 0.4rem;
  position: relative;
}
.el-tree-node .is-checked {
  background-color: #c2c2c2;
}
//修改弹出框样式
/deep/ .tree-popper{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/EXForm/EXSelectTree.vue